<template>
  <div>
    <div class="header">添加成员</div>
    <div>
      <el-form>
        <el-form-item>
          <span class="flotleft">姓名：</span>
          <el-input
            class="flotleft"
            style="width:350px;text-align:left"
            size="mini"
            placeholder="姓名"
          >ces</el-input>
          <br />
          <span class="flotleft">性别：</span>
          <el-radio class="flotleft" v-model="radio" label="1">男</el-radio>
          <el-radio class="flotleft" v-model="radio" label="2">女</el-radio>
          <br />
          <span class="flotleft">手机：</span>
          <el-input
            class="flotleft"
            style="width:300px;text-align:left"
            size="mini"
            placeholder="请输入内容"
          ></el-input>
          <br />
          <span class="flotleft">企业微信：</span>
          <el-input
            class="flotleft"
            style="width:300px;text-align:left"
            size="mini"
            placeholder="请输入内容"
          ></el-input>
          <br />
          <span class="flotleft">邮箱：</span>
          <el-input
            class="flotleft"
            style="width:300px;text-align:left"
            size="mini"
            placeholder="请输入内容"
          ></el-input>
          <br />
          <div>
            <span class="flotleft">部门：</span>
            <el-select
              class="flotleft"
              size="mini"
              v-model="value2"
              multiple
              collapse-tags
              placeholder="请选择"
            >
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
            <br />
            <div>
              <span class="flotleft">岗位：</span>
              <el-select
                class="flotleft"
                size="mini"
                v-model="value2"
                multiple
                collapse-tags
                placeholder="请选择"
              >
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
              <el-select
                class="flotleft"
                size="mini"
                v-model="value2"
                multiple
                collapse-tags
                placeholder="请选择"
              >
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
              <el-input
                class="flotleft"
                style="width:300px;text-align:left"
                size="mini"
                placeholder="能力系数"
              ></el-input>
            </div>
          </div>
          <br />
          <span class="flotleft">标签：</span>
          <el-input
            class="flotleft"
            style="width:300px;text-align:left"
            size="mini"
            placeholder="填写标签，用分号分隔"
          ></el-input>
          <br />
          <span class="flotleft">身份：</span>
          <el-radio class="flotleft" v-model="radio" label="3">普通成员</el-radio>
          <el-radio class="flotleft" v-model="radio" label="4">上级</el-radio>
          <br />
          <h2>个人档案</h2>
          <div style="text-align: left;">
            <span class="flotleft">简历附件：</span>
            <el-upload
              style="margin-left: 60px;width:600px"
              class="upload-demo"
              action="https://jsonplaceholder.typicode.com/posts/"
              :on-preview="handlePreview"
              :on-remove="handleRemove"
              :before-remove="beforeRemove"
              multiple
              :limit="3"
              :on-exceed="handleExceed"
              :file-list="fileList"
            >
              <el-button size="small" type="primary">上传附件</el-button>
              <!-- <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div> -->
            </el-upload>
          </div>
          <div style="text-align: left;">
            <span class="flotleft">入职简历：</span>
            <el-input
              style="width:600px;text-align:left;margin-bottom: 25px;"
              type="textarea"
              :autosize="{ minRows: 5, maxRows: 8}"
              placeholder="请输入内容"
              v-model="textarea2"
            ></el-input>
          </div>
          <div style="text-align: left;">
            <span class="flotleft">项目经历：</span>
            <el-input
              style="width:600px;text-align:left;margin-bottom: 25px;"
              type="textarea"
              :autosize="{ minRows: 5, maxRows: 8}"
              placeholder="请输入内容"
              v-model="textarea2"
            ></el-input>
          </div>
          <span class="flotleft">状态：</span>
          <el-select
            class="flotleft"
            size="mini"
            v-model="value2"
            multiple
            collapse-tags
            placeholder="请选择"
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <br />
          <div>
            <el-button type="primary">保存并继续添加</el-button>
            <el-button type="primary">保存</el-button>
            <el-button>返回</el-button>
          </div>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      options: [{
        value: '选项1',
        label: '张三'
      }, {
        value: '选项2',
        label: '李四'
      }, {
        value: '选项3',
        label: '王五'
      }, {
        value: '选项4',
        label: '赵六'
      }, {
        value: '选项5',
        label: '赵1'
      }, {
        value: '选项6',
        label: '赵4'
      }, {
        value: '选项7',
        label: '赵2'
      }, {
        value: '选项8',
        label: '赵3'
      }, {
        value: '选项9',
        label: '赵7'
      }, {
        value: '选项10',
        label: '周七'
      }],
      value1: [new Date(2016, 9, 10, 8, 40), new Date(2016, 9, 10, 9, 40)], // 时间日期
      value2: [], // 下拉选项
      fileList: [{ name: '演示例子.jpeg', url: 'https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100' }, { name: 'food2.jpeg', url: 'https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100' }],
      textarea2: '',
      radio: '1'
    }
  },
  methods: {
    handleRemove (file, fileList) {
      console.log(file, fileList)
    },
    handlePreview (file) {
      console.log(file)
    },
    handleExceed (files, fileList) {
      this.$message.warning(`当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`)
    },
    beforeRemove (file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`)
    }
  }
}
</script>

<style scoped>
.header {
  height: 30px;
  background-color: #dcdee2;
  line-height: 30px;
  border: 0.5px solid #e8eaec;
  text-align: left;
  /* 缩进2个字节 */
  text-indent: 2em;
}
.flotleft {
  float: left;
}
.outDiv {
  margin-left: 70px;
}
.divs {
  text-align: left;
  margin-left: 40px;
  margin-bottom: 15px;
}
</style>



// WEBPACK FOOTER //
// src/views/system-manage/AddMembers.vue